'use strict';

import React from 'react';
require('css/components/loader.scss');

const Loader = ({ height = 200 }) => {
  const elements = [];
  for (var i = 1; i <= 12; i++) {
    elements.push(<div className={`hu-loader-element-${i}`} key={i} ></div>);
  }

  return <div className="hu-loader" style={{ height }}>
    {elements}
  </div>;
};

module.exports = Loader;



// WEBPACK FOOTER //
// ./app/assets/jsx/components/loader.jsx